import { useMemo } from 'react';
import { api } from '@/redux/api';
import { updateUnitWithOrganisation } from '@/utils/update-unit-with-organisation';
import { useCurrentOrganisation } from './use-current-organisation';
import { useUser } from './use-user';

export const useUnits = () => {
  const { organisation } = useCurrentOrganisation();
  const { user } = useUser();

  const result = api.useGetUnitsQuery(
    { organisation: organisation! },
    {
      skip: organisation === undefined,
    },
  );

  const data = useMemo(() => {
    let units = (result.data ?? []).map((unit) =>
      organisation ? updateUnitWithOrganisation(unit, organisation) : unit,
    );

    const permittedGroups = user.permittedGroups;
    if (permittedGroups && permittedGroups.length > 0) {
      const permittedGroupIds = new Set(permittedGroups.map((g) => g.id));
      units = units.filter(
        (unit) => unit.group && permittedGroupIds.has(unit.group.id),
      );
    }

    return units;
  }, [result.data, organisation, user.permittedGroups]);

  const update = api.useUpdateUnitMutation();
  return { ...result, data, update };
};
